// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MuiStepLabel-label.Mui-error {\n      color: #000000 !important;\n    };", "",{"version":3,"sources":["webpack://src/components/Steps/style.css"],"names":[],"mappings":"AAAA;MACM,yBAAyB;IAC3B,CAAA","sourcesContent":[".MuiStepLabel-label.Mui-error {\n      color: #000000 !important;\n    };"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
